module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookMain",
    style: (_vm.bookMainStyles)
  }, [_c('div', {
    staticClass: "bookContainer",
    style: (_vm.bookContainerStyles)
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('div', {
      directives: [{
        name: "touch",
        rawName: "v-touch:swipe.left",
        value: (_vm.swipeLeft),
        expression: "swipeLeft",
        arg: "swipe",
        modifiers: {
          "left": true
        }
      }, {
        name: "touch",
        rawName: "v-touch:swipe.right",
        value: (_vm.swipeRight),
        expression: "swipeRight",
        arg: "swipe",
        modifiers: {
          "right": true
        }
      }],
      key: page.url,
      ref: "bookItem",
      refInFor: true,
      staticClass: "bookItem",
      class: [{
          rotate180: page.rotate180
        },
        page.left ? 'left' : 'right',
        page.animateClass
      ],
      style: ({
        zIndex: _vm.set_zIndex(index),
        animationDuration: page.animationDuration + 's'
      }),
      on: {
        "click": function($event) {
          return _vm.turn(index)
        }
      }
    }, [_vm._t("default", null, {
      "page": page,
      "index": index
    }), _vm._v(" "), (_vm.showPageIndex && _vm.startPageIndex <= index && _vm.endPageIndex >= index) ? _c('i', {
      staticClass: "index",
      class: index % 2 === 0 ? 'index-left' : 'index-right',
      style: (_vm.styleForPageIndex)
    }, [_vm._v(_vm._s(index + 1 - _vm.startPageIndex) + "\n      ")]) : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('book-navigation', {
    attrs: {
      "atFirstPage": _vm.atFirstPage,
      "atEndPage": _vm.atEndPage,
      "hasAudioSource": !!_vm.audioSource,
      "audioPlaying": _vm.audioPlaying,
      "color": _vm.color
    },
    on: {
      "turnLeftPage": _vm.turnLeftPage,
      "turnRightPage": _vm.turnRightPage,
      "goToHomePage": _vm.goToHomePage,
      "toggleAudio": _vm.toggleAudio
    }
  }), _vm._v(" "), (_vm.pages.length === 0) ? [_c('div', {
    staticClass: "bookItem left"
  }, [_c('loading-svg', {
    staticClass: "loading"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bookItem right"
  }, [_c('loading-svg', {
    staticClass: "loading"
  })], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d9a7d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-book-component/components/book/book.vue
// module id = 34
// module chunks = 0